import React from "react";
import ContentEditable from "react-contenteditable";
import "../../../../components/themes/aptean/styles-aptean.css";

const Feature9 = (props) => {
  const { brandGuidelines } = props;

  const handleChangeFunction = (element, event) => {
    const { blockKey, onContentChange } = props;
    if (event.target.value !== undefined) {
      onContentChange(blockKey, element, event.target.value);
    }
  };

  const { backgroundColours } = brandGuidelines;
  const { blockKey, formTitle, formText } = props;

  return (
    <section key={blockKey} class="bg-white py-6 lg:py-12">
      <div class="relative px-4 lg:container lg:mx-auto lg:px-20">
        <div class="flex justify-center">
          <div class="relative z-10 md:max-w-lg lg:max-w-xl xl:max-w-2xl">
            <div class="rounded-2xl bg-[#F8F7F5] py-6 px-8 shadow-[4px_4px_5px_rgba(0,0,0,0.25)] lg:py-8 lg:px-10 xl:rounded-[57px] xl:py-10 xl:px-12">
              <div
                class="wysiwyg-form-title"
                pardot-region="Feature-Variant-9--Form-Title"
              >
                <ContentEditable
                  html={formTitle}
                  disabled={false}
                  onChange={(event) => {
                    handleChangeFunction("formTitle", event);
                  }}
                />
              </div>
              <div class="mt-2 md:mt-4">
                <div
                  class="wysiwyg-text-base"
                  pardot-region="Feature-Variant-9--Form-Text"
                >
                  <ContentEditable
                    html={formText}
                    disabled={false}
                    onChange={(event) => {
                      handleChangeFunction("formText", event);
                    }}
                  />
                </div>
              </div>
              <div class="mt-2 md:mt-4">%%content%%</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Feature9;
